export const GENERIC_DEADLINE = {
  OUT_DEADLINE: 'OUT_DEADLINE',
  IN_DEADLINE: 'IN_DEADLINE',
  CLOSE_DEADLINE: 'CLOSE_DEADLINE',
};
